import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import useAxios from 'axios-hooks';
import isNumber from 'lodash.isnumber';
import Modal from 'react-modal';

import { Button } from '../../../../components';
import isEmpty from 'lodash.isempty';

const ViewQuestionnaireModal = ({ careQuestGroupId, onClose, isOpen }) => {
	const [{ data: groupData, loading: loadingGroup, /* error */ }, loadGroup] = useAxios({
		// url: '/care_quest_groups',
		method: 'GET',
	}, { manual: true });
	const [{ data: qAndAData, loading: loadingQsAndAs, /* error */ }, loadQsAndAs] = useAxios({
		url: '/care_quest_questions',
		method: 'GET',
	}, { manual: true });

	useEffect(() => {
		if (isOpen && isNumber(careQuestGroupId) && careQuestGroupId > 0) {
			loadGroup({
				url: `/care_quest_groups/${careQuestGroupId}`
			});
			loadQsAndAs({
				params: {
					filter: JSON.stringify({
						where: {
							care_quest_groupId: careQuestGroupId
						},
						include: [{
							relation: 'care_quest_answers',
							order: ['answer_order ASC']
						}],
						order: ['question_order ASC']
					})
				}
			});
		}
	}, [careQuestGroupId, isOpen]);

	return (
		<Modal isOpen={isOpen} contentLabel="Campaign Questionnaire" className="modal-dialog questionnaire-display-modal modal-lg">
			<div className="modal-content">
				<div className="modal-header">
					<div className="clearfix">
						<div className="pull-right">
							<button className="btn btn-link" onClick={onClose}>
								<em className="fa fa-lg fa-times" />
							</button>
						</div>
						<h3 className="modal-title">
							Campaign Questionnaire
						</h3>
					</div>
				</div>
				<div className="modal-body">
					{(loadingGroup || loadingQsAndAs) && (
						<div>Loading campaign questionnaire...</div>
					)}
					{!loadingGroup && groupData && (
						<React.Fragment>
							<h4>Title</h4>
							<p>{groupData.name}</p>
							<h4>Header</h4>
							<p>{isEmpty(groupData.header_text) ? (
								<em>No header text</em>
							): groupData.header_text}</p>
						</React.Fragment>
					)}
					{!loadingQsAndAs && qAndAData && (
						<React.Fragment>
							<h4>Questionnaire</h4>
							<ol>
								{qAndAData.map((question) => (
									question.conditional_parent_question_id ? (
										<ul key={question.id}>
											<li>
												<strong>{question.question_text}</strong>
												<ul>
													{question.care_quest_answers.map((answer) => (
														<li key={`answer-${answer.id}`}>{answer.answer_text}</li>
													))}
												</ul>
											</li>
										</ul>
									) : (
										<li key={question.id}>
											<strong>{question.question_text}</strong>
											<ul>
												{question.care_quest_answers.map((answer) => (
													<li key={`answer-${answer.id}`}>{answer.answer_text}</li>
												))}
											</ul>
										</li>
									)
								))}
							</ol>
						</React.Fragment>
					)}
				</div>
				<div className="modal-footer">
					<div className="pull-right">
						<Button
							title="Close"
							onClick={onClose}
							large
							primary
							className="ml"
						/>
					</div>
				</div>
			</div>
		</Modal>
	);
};

ViewQuestionnaireModal.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	careQuestGroupId: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
};

export default ViewQuestionnaireModal;
